import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Package } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { Page } from "@/components/Page";

const STATUSES = ["Placed", "Confirmed", "Shipped", "Delivered", "Cancelled"];

export default function MyOrders() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/dashboard").then(r => setItems(r.data.orders || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const setStatus = async (o, status) => {
    try { await api.put(`/orders/${o.id}/status`, { status }); toast.success(`Marked ${status}`); load(); }
    catch (err) { toast.error(formatError(err)); }
  };
  return (
    <Page title="My orders" subtitle="Orders customers have placed on your listings. Update status to trigger buyer SMS.">
      {items.length ? (
        <div className="admin-table" data-testid="my-orders-table">
          <div className="admin-row admin-head"><span>Product</span><span>Buyer</span><span>Phone</span><span>Total</span><span>Status</span></div>
          {items.map(o => (
            <div className="admin-row" key={o.id} data-testid={`my-order-${o.id}`}>
              <span>{o.product_name} × {o.quantity}</span>
              <span>{o.buyer_name}<br /><small className="muted">{o.buyer_email}</small></span>
              <span>{o.buyer_phone}</span>
              <span>₹{Number(o.total).toLocaleString("en-IN")}</span>
              <span>
                <select value={o.status} onChange={e => setStatus(o, e.target.value)} data-testid={`my-order-status-${o.id}`}>
                  {STATUSES.map(s => <option key={s}>{s}</option>)}
                </select>
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Package size={26} />
          <h3>No orders yet</h3>
          <p>When a customer places an order for one of your products, it appears here.</p>
        </div>
      )}
    </Page>
  );
}
